export default __webpack_public_path__ + "720c13170015478ead0aa99ae8476081.svg";